/* eslint-disable */
import styled from 'styled-components';

const SetDefaultCoursesWrapper = styled.div`
    position: relative;
`;

export { SetDefaultCoursesWrapper };


// WEBPACK FOOTER //
// ./app/containers/set-default-courses/styled.js